import { Component, OnInit, Output } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { ActivitiHandlerService } from './../common/services/activitiHandler.service';
import { CookieHandlerService } from './../common/services/cookieHandler.service';
import { CommonConstants } from './../common/utilities/commonConstants';
import { SharedService } from './../common/services/sharedService';
import { Formatter } from './../common/services/formatter';
import { AnalyticsService } from './../common/services/device.analytics.service';
import { RouteHandlerService } from './../common/services/routeHandler.service';
import { HttpInterceptor } from './../common/services/httpInterceptor.service';
import { SessionHandlerService } from '../common/services/sessionHandler.service';
import { ConfigService } from '../common/services/config.service';

const RESP = {
    'payload': {
        'newTokens': {
            'tokens': [{
                // tslint:disable-next-line:max-line-length
                'token': 'eyJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJCYWphakZpblNlcnYiLCJleHAiOjE1NDk5NzE2NzIsImlhdCI6MTUzNDQxOTY3Miwic3ViIjoiYXV0aGVudGljYXRpb24iLCJsb2dpbiI6Ijk5NTUyNjEwNjdAMTk5MS0xMS0xMSIsInVzZXJUeXBlIjoxfQ.9T-Di3c1rzQRN6-G8kApO8AAroE2mqgiJ678202QjFo',
                'guardKey': 'dR5M75FkTbFO',
                'type': 'authtoken'
            }]
        },
        'application': [{
            'applicationKey': 111129,
            'prodCategory': 'CYBGI',
            'loanProduct': 'Educational Loan',
            'loanProductType': null,
            'applicationCreationDate': '16 Aug 2018',
            'loanApplicationKey': null,
            'appCompletionPercentage': 50,
            'lastAccessedTime': 0,
            'processId': '355558',
            'resumable': true,
            'applicantkey': 41344,
            'customerFirstName': 'Name',
            'customerFullName': 'Name Surname',
            'customerLastName': 'Surname',
            'customerDob': '1991-11-11',
            'finnoneId': null,
            'mobileNumber': '9955261067',
            'officialEmail': null,
            'panNumber': 'PALLAVI12345H',
            'pennantId': null,
            'personalEmail': 'abcd@gmail.com',
            'applicationApplicantId': 44540
        },
        {
            'applicationKey': 101008,
            'prodCategory': 'ULBOL',
            'loanProduct': 'Personal Loan',
            'loanProductType': null,
            'applicationCreationDate': '18 Jul 2018',
            'loanApplicationKey': 84791,
            'appCompletionPercentage': 80,
            'lastAccessedTime': 0,
            'processId': '83165',
            'resumable': true,
            'applicantkey': 6833,
            'customerFirstName': 'Kamlesh',
            'customerFullName': 'Kamlesh',
            'customerLastName': 'Banosekar',
            'customerDob': '1987-03-19',
            'finnoneId': null,
            'mobileNumber': '9422200383',
            'officialEmail': 'sham.jadhav@cognizant.com',
            'panNumber': 'ABcSD',
            'pennantId': null,
            'personalEmail': 'shambjadhav@gmail.com',
            'applicationApplicantId': 39135
        }
        ],
    },
    'userInput': null,
    'status': 'SUCCESS',
    'errorBean': null,
    'nextTaskKey': 'cShowApplicationList',
    'progressInfo': {
        'payload': [{
            'name': 'Explore Right Plan',
            'value': 100,
            'active': false
        }, {
            'name': 'Application Stage',
            'value': 0,
            'active': true
        }, {
            'name': 'Final Check',
            'value': 0,
            'active': false
        }, {
            'name': 'Close The Deal',
            'value': 0,
            'active': false
        }],
        'status': 'SUCCESS',
        'errorBean': null
    },
    'routesInfo': {
        'mainRoute': 'applicationList',
        'subRoute': ''
    }
};
@Component({
    templateUrl: './existingCustomer.template.html',
    styleUrls: ['./existingCustomer.style.scss']
})
export class ExistingCustomerComponent implements OnInit {
    public SelectApplication: FormGroup;
    public ApplicationList: any;
    public UserName: string;
    public AppSelectionOptions: any;
    public LoanTypes = [];
    public DetailsPayload;
    public ShowLoader: boolean;
    public LoanProducts: any = {};
    public SelectedApplication: string = null;
    public SelectedProcessId: string;
    public SelectedLoanTypeDetails: any = {};
    public ProductEndUseForm: FormGroup;
    public LoanTypeVisibilityFlag: boolean;
    public SelectedEmiDate: string;
    public isFlexiHybridLoanOnLoad: boolean;
    public displayPage: boolean;
    public showLoader = true;
    @Output() public loanApplicationKey;
    public mobileNumber: any;
    public applicationId: any;
    public LatestQuoteData: any;
    public QuoteStagePercentage: any;
    public QuoteId: any;
    public appQuoteCriteriaId: any;
    public quoteCriteria: any;
    public quoteItemId: any;
    constructor(
        private _activitiHandler: ActivitiHandlerService,
        public _cookieHandler: CookieHandlerService,
        private _formBuilder: FormBuilder,
        private _formatter: Formatter,
        private _httpInterceptor: HttpInterceptor,
        private _routerService: RouteHandlerService,
        private sharedService: SharedService,
        private _analyticsService: AnalyticsService,
        private _sessionService: SessionHandlerService
    ) { }
    public ngOnInit() {
        this.buildFormProductGroup();
        const uName = this._cookieHandler.GetCookie(
            CommonConstants.CookieKeys.UserName) || CommonConstants.DEFAULT_EMPTY_STRING;
        this.UserName = atob(uName);
        this.getApplicationList();
    }
    public OnSubmit(formValue: FormData) {
        if (formValue['productName'] !== null && formValue['productName'] !== '') {
            const prdCode = this.sharedService.getData(CommonConstants.QueryParamsKeys.Productcode)
                || CommonConstants.LOAN_PRODUCT_CODES.Health_Insurance;
            const payload = this.setUtmParamsToPayload(prdCode,
                CommonConstants.LOAN_PRODUCT_CATEGORY_CODES.Health_Insurance,
                (mtResponse: ActivitiModel.MTResponse<any>) => {
                    // blank
                });
            this.taskComplete(payload, 'terminate', () => {
                this.setCookies(formValue);
                this.resumeApplication();
            });
        } else {
            // for time being remove below code
            this._cookieHandler.DeleteCookies([
                CommonConstants.CookieKeys.applicationId,
                CommonConstants.CookieKeys.LoanApplicationKey],
                this._sessionService.GetSession(CommonConstants.CookieKeys.applicationId));
            let appKey: string;
            let loanApplicationKey: string;
            this.ApplicationList.forEach((obj) => {
                if (obj.processId === formValue['productName']) {
                    appKey = obj.applicationKey.toString();
                    loanApplicationKey = obj.applicationKey.toString();
                }
            });
            this._cookieHandler.SetCookie(CommonConstants.CookieKeys.applicationId, appKey);
            this._sessionService.SetSession(CommonConstants.CookieKeys.applicationId, appKey);
            this._sessionService.SetSession(CommonConstants.CookieKeys.LoanApplicationKey,
                loanApplicationKey);
            this._sessionService.SetSession(CommonConstants.CookieKeys.JourneyType, 'Resume');
            console.log(this._sessionService.GetSession(
                CommonConstants.CookieKeys.LoanApplicationKey));
            const startWorkFlowpayload = {
                productCategoryCode: CommonConstants.LOAN_PRODUCT_CATEGORY_CODES.Health_Insurance,
                insuranceApplications: {
                    insProduct: CommonConstants.LOAN_PRODUCT_CODES.Health_Insurance
                },
                applicantId: this.ApplicationList[0].applicantkey,
                applicationId: this.ApplicationList[0].applicationKey,
                appApplicantId: this.ApplicationList[0].applicationApplicantId
            };
            this.taskRouteComplete(startWorkFlowpayload, 'ContinueNew');
        }
    }
    public ResumeLoginBack(action: string) {
        this._activitiHandler.MarkTaskAsCompleted(null, action, true).subscribe((mtResponse: ActivitiModel.MTResponse<any>) => {
            if (!mtResponse.errorBean) {
                this.sharedService.setData(
                    CommonConstants.SharedServiceDataKeys.IsNewApplication, false);
                this._routerService.RouteToNextTask(mtResponse.nextTaskKey);
            }
        });
    }
    public GoBack() {
        this._activitiHandler.MarkTaskAsCompleted(null, 'Back', true).subscribe((mtResponse: ActivitiModel.MTResponse<any>) => {
            if (!mtResponse.errorBean) {
                this.sharedService.setData(
                    CommonConstants.SharedServiceDataKeys.IsNewApplication, false);
                this._routerService.RouteToNextTask(mtResponse.nextTaskKey);
            }
        });
    }
    public OnAppSelection($event: any) {
        this.SelectedProcessId = $event[0].processId;
        this.setProcessId();
    }
    private setProcessId() {
        this.SelectApplication.controls['productName'].setValue(this.SelectedProcessId);
    }
    private setCookies(formValue: FormData) {
        this._sessionService.DeleteSession([
            CommonConstants.CookieKeys.applicationId,
            CommonConstants.CookieKeys.LoanApplicationKey]);
        let appKey: string;
        let loanApplicationKey: string;
        this.ApplicationList.forEach((obj) => {
            if (obj.processId === formValue['productName']) {
                appKey = obj.applicationKey.toString();
                loanApplicationKey = obj.applicationKey.toString();
            }
        });
        const appIdFromCookie = this._cookieHandler.GetCookie(CommonConstants.CookieKeys.applicationId, appKey);
        if (((appKey === appIdFromCookie) && appKey && appIdFromCookie) && !this._analyticsService.GetDeviceDetails().mobile) {
            this._routerService.RouteToNextTask('multitabfailed');
            return;
        }
        this._sessionService.SetSession(CommonConstants.CookieKeys.applicationId, appKey);
        this._cookieHandler.SetCookie(CommonConstants.CookieKeys.applicationId, appKey, appKey);
        this._sessionService.SetSession(CommonConstants.CookieKeys.LoanApplicationKey,
            loanApplicationKey);
        this._sessionService.SetSession(CommonConstants.CookieKeys.ProcessInstanceDetails,
            formValue['productName']);
        this._sessionService.SetSession(CommonConstants.CookieKeys.JourneyType, 'Resume');
        console.log(this._sessionService.GetSession(
            CommonConstants.CookieKeys.LoanApplicationKey));
    }
    private findAppKey(proID: string) {
        this._sessionService.DeleteSession([CommonConstants.CookieKeys.applicationId]);
        let obj: any;
        for (obj in this.ApplicationList) {
            if (obj.processId === proID) {
                this._sessionService.SetSession(CommonConstants.CookieKeys.LoanApplicationKey,
                    obj.applicationKey);
            }
        }
    }
    private getApplicationList() {
        this.mobileNumber = this.sharedService.getData(
            CommonConstants.SharedServiceDataKeys.WebsiteResumeMobileNumber);
        // ----------------------get application call-----------------------------------
        let url = ConfigService.getInstance()
            .getConfigObject().APIURL.QuoteListingGetCall;
        url = url.replace('{mobileNo}', this.mobileNumber);
        url = url.replace('{productCategory}', 'HGI');
        url = url.replace('{additionalParam}', '');
        // -------------------get quote call----------------------------
        this._httpInterceptor.Get(url).subscribe((mtResponse) => {
            if (!mtResponse.errors) {
                this.applicationId = mtResponse.payload.applicationId;
                let url2 = ConfigService.getInstance()
                    .getConfigObject().APIURL.GetQuoteList;
                url2 = url2.replace('{applicationId}', this.applicationId);
                this._httpInterceptor.Get(url2).subscribe((response) => {
                    this.ApplicationList = response;
                    this.LatestQuoteData = response[0];
                    this.QuoteStagePercentage = this.LatestQuoteData.statusDetail.percentage;
                    this.QuoteId = this.LatestQuoteData.quoteId;
                    this.appQuoteCriteriaId = this.LatestQuoteData.appQuoteCriteriaId;
                    this.quoteCriteria = this.LatestQuoteData.quoteCriteria;
                    this.quoteItemId = this.LatestQuoteData.quoteItemId;
                    // ----------------- post quote call---------------------------
                    const url3 = ConfigService.getInstance()
                        .getConfigObject().APIURL.QuoteListingPostCall;
                    const ListingRequestData = this.ListingRequestPayload();
                    this._httpInterceptor.Post(url3, ListingRequestData).subscribe((res) => {
                        if (!mtResponse.errors) {
                            this._routerService.RouteToNextTask(res.nextTask.nextTaskKey);
                            this.showLoader = false;
                        }
                    });
                });

            }
            this.setApplicationOptionsList(this.ApplicationList);

        });
    }
    private ListingRequestPayload() {
        return {
            'payload': {
                'quoteCriteria': this.quoteCriteria,
                'mobile': this.mobileNumber,
                'productCode': 'HGI',
                'qStagePercent': this.QuoteStagePercentage,
                'dob': '',
                'quoteId': this.QuoteId,
                'applicationId': this.applicationId,
                'appQuoteCriteriaId': this.appQuoteCriteriaId,
                'vehicleRegId': '',
                'prevPolicyDetId': '',
                'quoteItemId': this.quoteItemId,
            },
            'action': 'resume'
        };
    }

    // Setting Application List Selection List Object
    private setApplicationOptionsList(loanTypes) {
        this.AppSelectionOptions = {
            itemHighlightSelector: '.product-row',
            itemSelector: '.product-row',
            isMultiSelect: false,
            isSelectionToggleAllowed: false,
            DataProvider: loanTypes
        };
    }
    // this is the place where user from customer portal will go to direct appliaction.
    private findAndredirectToResumeApp() {
        const getProceessIDForResume = this._cookieHandler.GetCookie('SS_1_APP_PRO_ID');
        this.findAppKey(getProceessIDForResume);
        if (getProceessIDForResume != null) {
            this._sessionService.SetSession(
                CommonConstants.CookieKeys.ProcessInstanceDetails, getProceessIDForResume);
            this.resumeApplication();
        }
    }
    private buildFormProductGroup(): void {
        this.SelectApplication = this._formBuilder.group({
            productName: ['', Validators.compose([Validators.required])],
            ulKey: ['']
        });
    }
    private taskComplete(data, actionName, callback?) {
        this._activitiHandler.MarkTaskAsCompleted(data, actionName).subscribe((mtresponse: ActivitiModel.MTResponse<any>) => {
            if (!mtresponse.errorBean) {
                console.log(mtresponse.payload, 'payload marktask complete');
                if (callback) {
                    callback();
                }
            }
        });
    }
    private resumeApplication() {
        this._activitiHandler.GetTaskDetails().subscribe((res: ActivitiModel.MTResponse<any>) => {
            if (!res.errorBean) {
                if (res.nextTaskKey === CommonConstants.EMIOTPNEXTTASKKEY) {
                    this.ResumeLoginBack('Back');
                } else if (res.nextTaskKey === 'hrshowapplicationlist') {
                    this.ResumeLoginBack('resumeBack');
                } else if (res.nextTaskKey === 'revampLogin') {
                    this.ResumeLoginBack('Modify');
                } else {
                    this._routerService.RouteToNextTask(res.nextTaskKey);
                }
            }
        });
    }
    private checkMannualRouting(payload: any) {
        this.sharedService.setData('quesObj', payload);
    }
    private setUserAuthToken(responseData: any) {
        console.log(responseData);
        if (responseData && responseData.newTokens &&
            responseData.newTokens.tokens && responseData.newTokens.tokens.length) {
            this._sessionService.SetSession(CommonConstants.CookieKeys.JWToken,
                responseData.newTokens.tokens[0].token);
            this._sessionService.
                SetSession(CommonConstants.CookieKeys.GuardKey,
                    responseData.newTokens.tokens[0].guardKey);
            this._sessionService.SetSession(CommonConstants.CookieKeys.GuardToken,
                this._formatter
                    .ConvertGuradKeyToGuardToken(
                        responseData.newTokens.tokens[0].guardKey));
        }
    }
    private setUtmParamsToPayload(
        loanProduct: string,
        productCategoryCode: string,
        onSuccessCallback: Function,
        calculatorProductType?: number,
        isLocationProvided?: boolean
    ): any {
        const payload = this.getApplicationCreateRequest(
            loanProduct, productCategoryCode, calculatorProductType, isLocationProvided);
        return payload;
    }
    private getApplicationCreateRequest(
        LoanProduct: string,
        ProductCategoryCode: string,
        CalculatorProductType?: number,
        IsLocationProvided?: boolean) {
        let mediumFromWeb = this.sharedService.getData(CommonConstants.QueryParamsKeys
            .appUtmMedium);
        const medium = 'Webengage_repeat_visitor_finance_homepage_PL_apply_online_link';
        if (mediumFromWeb !== '' && typeof (mediumFromWeb) !== 'object') {
            mediumFromWeb = this.CheckUtmMediumForDevice(
                this.sharedService.getData(CommonConstants.QueryParamsKeys
                    .appUtmMedium).toString());
        } else if (mediumFromWeb !== '') {
            mediumFromWeb = this.CheckUtmMediumForDevice(medium);
        } else {
            mediumFromWeb = this.CheckUtmMediumForDevice(mediumFromWeb);
        }
        return {
            appJourneyStamp: 'journeyStamp',
            appSource: 'Browser',
            appStatus: 0,
            bflBranch: this.checkUtmSources(this.sharedService.getData(
                CommonConstants.QueryParamsKeys.BFLBranch)) || '320',
            productCategoryCode: ProductCategoryCode,
            loanApplications: { loanProduct: LoanProduct },
            calculatorProductType: CalculatorProductType,
            islocationProvided: IsLocationProvided,
            appUtmRefCode: this.checkUtmSources(this.sharedService.getData(
                CommonConstants.QueryParamsKeys.appUtmRefCode)) || '',
            appUtmSource: this.checkUtmSources(this.sharedService.getData(
                CommonConstants.QueryParamsKeys.appUtmSource)) || 'Organic',
            appUtmMedium: mediumFromWeb || medium,
            appUtmCampaign: this.checkUtmSources(this.sharedService.getData(
                CommonConstants.QueryParamsKeys.appUtmCampaign)) || '',
            appUtmTerm: this.checkUtmSources(this.sharedService.getData(
                CommonConstants.QueryParamsKeys.appUtmTerm)) || '',
            appUtmContent: this.checkUtmSources(this.sharedService.getData(
                CommonConstants.QueryParamsKeys.appUtmContent)) || '',
            gclId: this.checkUtmSources(this.sharedService.getData(
                CommonConstants.QueryParamsKeys.GCLID))
                || 'EAIaIQobChMIsZGIyZn01AIV1IdoCh19HAKqEAAYASAAEgKWjfD_BwE'
        };
    }
    private CheckUtmMediumForDevice(value: string) {
        const deviceDetails: DeviceDetails = this._analyticsService.GetDeviceDetails();
        if (deviceDetails.mobile) {
            value = value.concat('_mobile');
        }
        return value;
    }
    private checkUtmSources(utmObj) {
        if (Object.keys(utmObj).length !== 0) {
            return utmObj;
        } else {
            return false;
        }
    }
    private taskRouteComplete(data, actionName, callback?) {
        this._activitiHandler.MarkTaskAsCompleted(data, actionName).subscribe((mtresponse: ActivitiModel.MTResponse<any>) => {
            if (!mtresponse.errorBean) {
                console.log(mtresponse.payload, 'payload marktask complete');
                this._routerService.RouteToNextTask(mtresponse.nextTaskKey);
            }
        });
    }
}
